import React, { createContext, useContext, useCallback, useEffect, useState } from "react";
import { getTimeOffRequests } from "../services/timeOffService";
import { usePermissions } from "../hooks/usePermission";

const PendingApprovalsContext = createContext({ pendingCount: 0, refreshPendingCount: () => {} });

const POLL_INTERVAL_MS = 60000;

export function PendingApprovalsProvider({ children }) {
  const { canApproveTimeOff } = usePermissions();
  const [pendingCount, setPendingCount] = useState(0);

  const refreshPendingCount = useCallback(async () => {
    if (!canApproveTimeOff) {
      setPendingCount(0);
      return;
    }
    try {
      const requests = await getTimeOffRequests({ status: "pending" });
      setPendingCount(Array.isArray(requests) ? requests.length : 0);
    } catch (error) {
      // Keep the app usable even if the count fails to load.
    }
  }, [canApproveTimeOff]);

  useEffect(() => {
    if (!canApproveTimeOff) {
      setPendingCount(0);
      return undefined;
    }
    refreshPendingCount();
    const interval = setInterval(refreshPendingCount, POLL_INTERVAL_MS);
    return () => clearInterval(interval);
  }, [canApproveTimeOff, refreshPendingCount]);

  return (
    <PendingApprovalsContext.Provider value={{ pendingCount, refreshPendingCount }}>
      {children}
    </PendingApprovalsContext.Provider>
  );
}

export const usePendingApprovals = () => useContext(PendingApprovalsContext);

export default PendingApprovalsContext;
